import { render, staticRenderFns } from "./equipment-manage.vue?vue&type=template&id=b24e49a2&scoped=true"
import script from "./equipment-manage.vue?vue&type=script&lang=js"
export * from "./equipment-manage.vue?vue&type=script&lang=js"
import style0 from "./equipment-manage.vue?vue&type=style&index=0&id=b24e49a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24e49a2",
  null
  
)

export default component.exports